window.Fav = {};

Fav.loadFavs = function (cb) {
  return jQuery.ajax({
    url: "/client/favorites/fetch",
    method: "post",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      if (cb) {
        return cb(resp);
      }
      Fav.updateItemsQtyLabel(resp.favorites.length);
    }
  });
};

Fav.favProduct = function (productId, cb) {
  return jQuery.ajax({
    url: "/client/favorites/add?productId=" + productId,
    method: "post",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      cb && cb(null, resp);
    },
    error: function (resp) {
      cb && cb(resp);
    }
  });
};

Fav.unFavProduct = function (productId, cb) {
  return jQuery.ajax({
    url: "/client/favorites/remove?productId=" + productId,
    method: "post",
    contentType: 'application/json; charset=utf-8',
    success: function (resp) {
      cb && cb(null, resp);
    },
    error: function (resp) {
      cb && cb(resp);
    }
  });
};

Fav.updateItemsQtyLabel = function (number) {
  var spanQ = '.wishlist .icon-heart span';
  var span = $(spanQ);
  if (number === 0) {
    span.remove();
    return;
  }
  if (!span.length) {
    $('.wishlist .icon-heart').append("<span></span>");
    span = $(spanQ);
  }
  span.html(number);
};




